// Lucide icon: trash-2 (https://lucide.dev/icons/trash-2)
import { Trash2 } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconDelete = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Trash2 />
    </IconComponentStyled>
  )
}
